import { useQuery } from '@tanstack/react-query';

import { getUserMeta } from '~modules/user/api/service/lessor-user';

export const useGetUserMeta = () => {
  return useQuery({
    queryKey: ['user-meta'],
    queryFn: getUserMeta,
    meta: {
      skipGlobalErrorToast: true,
    },
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};
